import {
  AxiosMethod,
  defaultAxiosOptions,
  OrderType,
  serviceEndpoints,
} from '../../constants';
import {
  DataFiltersModel,
  FilterPeriodType,
  PaginationModel,
  PartnerModel,
} from '../../models';
import { AxiosPromise, AxiosRequestConfig } from 'axios';
import useAxios from 'axios-hooks';
import { useNetworkErrorHandler } from '../../store/reducers/popupAlertsReducer';
import { getDatePeriodByType } from '../../components/date-filters/DateFilters.utils';
import { ResponseValuesOverride } from '../../models/response-values-override';

export function useGetPartnersForFilters(): [
  ResponseValuesOverride<PartnerModel[]>,
  (params: DataFiltersModel) => AxiosPromise<PaginationModel<PartnerModel>>,
] {
  const config: AxiosRequestConfig = {
    method: AxiosMethod.Get,
    url: serviceEndpoints.partnersApi(),
  };

  const defaultParams: DataFiltersModel = {
    ...getDatePeriodByType(FilterPeriodType.Last30, 0),
    page: 0,
    perPage: 9999999,
    orderColumn: 'statCnt',
    orderType: OrderType.Desc,
    filterByUsers: '-',
  };

  const [resp, execute] = useAxios<PaginationModel<PartnerModel>>(
    { ...config, params: defaultParams },
    { ...defaultAxiosOptions },
  );

  useNetworkErrorHandler(resp.error);

  const getPartnersForFilters = (params: DataFiltersModel) => {
    return execute({
      ...config,
      params: {
        ...defaultParams,
        ...params,
      },
    });
  };

  return [
    {
      ...resp,
      data: resp?.data?.data,
    } as unknown as ResponseValuesOverride<PartnerModel[]>,
    getPartnersForFilters,
  ];
}
